// extracted by mini-css-extract-plugin
export var aboveInput = "_lt-0";
export var actionButton = "_lt-5";
export var actionButtonContainer = "_lt-1";
export var actionIcon = "_lt-6";
export var aiInfoContainer = "_lt-2";
export var attachmentWrapper = "_lt-7";
export var bold = "_lt-3";
export var checkIcon = "_lt-8";
export var clickingRecipientBar = "_lt-11";
export var commentThreadSwitch = "_lt-a";
export var draftImage = "_lt-b";
export var draftImageContainer = "_lt-c";
export var draftImages = "_lt-e";
export var editButton = "_lt-g";
export var editor = "_lt-f";
export var editorContainer = "_lt-y";
export var editorErrorTooltipWrapper = "_lt-9";
export var headerDivider = "_lt-h";
export var icon = "_lt-i";
export var info = "_lt-j";
export var internal = "_lt-n";
export var internalDivider = "_lt-k";
export var internalMessage = "_lt-l";
export var messageInputCard = "_lt-m";
export var messageInputForm = "_lt-o";
export var messageInputFormInternal = "_lt-p";
export var options = "_lt-q";
export var publicMessageCustomer = "_lt-s";
export var publicMessageMerchant = "_lt-r";
export var removeImageButton = "_lt-d";
export var replyButtons = "_lt-t";
export var showSignatureButton = "_lt-u";
export var spinner = "_lt-v";
export var verticalButtonDivider = "_lt-4";
export var visibilitySelector = "_lt-w";
export var warning = "_lt-x";
export var wrappingText = "_lt-z";
export var writingInternalNoteTopBorder = "_lt-10";